import { pageTypes } from 'config/pageTypes';
import minMaxImg from 'assets/images/sgp/10x10/alt2.webp';
import versatileImg from 'assets/images/sgp/10x10/alt3.webp';
import altImg from 'assets/images/sgp/10x10/alt-content-image.webp';
import packingTipsImg from 'assets/images/sgp/10x10/packing.webp';
import locationImg from 'assets/images/sgp/10x10/location.webp';
import amenitiesImg from 'assets/images/sgp/10x10/amenities.webp';
import tenByTenHero from 'assets/images/sgp/hero/sgp-general-hero-optimized.webp';
import furniture from 'assets/images/sgp/10x10/Why 10x10/furniture.svg';
import home from 'assets/images/sgp/10x10/Why 10x10/home.svg';
import moving from 'assets/images/sgp/10x10/Why 10x10/moving.svg';
import shop from 'assets/images/sgp/10x10/Why 10x10/shop.svg';
import videoImage from 'assets/images/sgp/10x10/10x10-size-guide.webp';
import bedRoomImage from 'assets/images/sgp/10x10/bedroom.svg';
import furnitureImage from 'assets/images/sgp/10x10/furniture.svg';
import booksImage from 'assets/images/sgp/10x10/books.svg';
import movingImage from 'assets/images/sgp/10x10/moving.svg';
import shopImage from 'assets/images/sgp/10x10/shop.svg';
import timingImg from 'assets/images/sgp/10x10/hour.svg';
import saveMoneyImg from 'assets/images/sgp/10x10/save-money.svg';
import homeImg from 'assets/images/sgp/10x10/home.svg';
import generalAdvice from 'assets/images/sgp/10x10/relatedContent/storage-unit-size.webp';
import generalAdvice2 from 'assets/images/sgp/10x10/relatedContent/how-storage-unit-measured.webp';
import generalAdvice3 from 'assets/images/sgp/10x10/relatedContent/10x10-storage.webp';
import generalAdvice4 from 'assets/images/sgp/10x10/relatedContent/10x15-storage-unit.webp';
import threeColumnTableImage from 'assets/images/sgp/threeColumnTable.svg';
import fourColumnTableImage from 'assets/images/sgp/fourColumnTable.svg';
import twoColumnTableImage from 'assets/images/sgp/twoColumnTable.svg';

const TenByTenHeroContent = {
	title: '5X15 Storage Hero',
	background: 'yellow',
	modules: [
		{
			type: 'hero',
			id: '10x10-storage-hero',
			pageType: 'SGP',
			title: 'Locker Storage Hero',
			background: 'yellow',
			props: {
				content: {
					title: 'Medium Sized Storage: A 10x10 Storage Unit Is Your Perfect Match',
					pageType: 'SGP',
					inputLabel: 'Find Your Ideal 10x10 Storage Unit',
					description:
						"Drowning in stuff but not ready to part with it all? Whether you're downsizing, decluttering, or simply need more space at home, a 10x10 storage unit offers the perfect balance of space and affordability. At 100 square feet, it's roomy enough for major life transitions yet budget-friendly enough for everyday use.",
					image: tenByTenHero,
					CTAText: 'Search Storage Units Now',
				},
				additionalProps: {
					heading: {
						family: 'rounded',
					},
				},
			},
		},
	],
};

const TenByTenNearbyUnitsContent = {
	title: 'nearby units',
	background: 'gray',
	modules: [
		{
			type: 'facilitiesNearYou',
			props: {
				title: 'Popular Facilities Near',
			},
		},
	],
};

const iconContentData = {
	headerContent: {
		prefix: '## The Storage Size That’s Just Right',
		title: 'Why a 10x10 Storage Unit Works for Almost Everyone',
		description:
			"A 10x10 storage unit hits that sweet spot – not too small, not too large, but just right for most storage needs. Here's why it's one of our most popular sizes:",
	},
	itemsContent: {
		items: [
			{
				icon: furniture,
				title: '#### Perfect for apartments',
				description:
					'Store seasonal items, extra furniture, and keepsakes without cluttering your living space.',
			},
			{
				icon: moving,
				title: '#### Moving flexibility',
				description:
					'Bridge the gap between homes or store belongings during renovations.',
			},
			{
				icon: home,
				title: '#### Life transitions',
				description:
					'Ideal for college students, military families, or anyone in temporary housing.',
			},
			{
				icon: shop,
				title: '#### Business storage',
				description:
					'Great for small business inventory, files, or equipment.',
			},
		],
	},
	props: {
		type: 'IconContentBlock',
	},
};

const TenByTenIconContent = {
	title: 'Icon Content Block',
	background: 'gray',
	modules: [
		{
			type: 'IconContentBlock',
			id: '10x10-icon-content',
			props: iconContentData,
		},
	],
};

const TenByTenSmallTableContent = {
	title: 'Size Guide',
	background: 'gray',
	pageType: 'SGP',
	modules: [
		{
			type: 'sizeChart',
			props: {
				title: '10x10 Storage Unit Size Guide & Comparison',
				suffix: '### Understanding Your Space: How Big is a 10x10 Storage Unit?',
				image: twoColumnTableImage,
				description:
					'A 10x10 storage unit provides 100 square feet of storage space with 8-foot ceilings (some facilities offer 9-10-foot ceilings). To put this in perspective:',
				type: 'sizeChart',
				id: '10x10-small-table',
				slug: 'size-chart-section',
				pageType: 'SGP',
				tableType: 'specialType',
				headers: [
					{
						label: 'Comparison',
						key: 'Comparison',
					},
					{
						label: 'Size',
						key: 'Size',
					},
				],
				rows: [
					{
						Comparison: {
							type: 'markdown',
							markdown: '**10x10 Storage Unit**',
						},
						Size: '100 sq ft',
					},
					{
						Comparison: 'Large bedroom',
						Size: '100-120 sq ft',
					},
					{
						Comparison: 'Small garage',
						Size: '200-250 sq ft',
					},
					{
						Comparison: 'Studio apartment',
						Size: '300-400 sq ft',
					},
					{
						Comparison: 'One-car garage stall',
						Size: '120-150 sq ft',
					},
				],
			},
		},
	],
};

const TenByTenVideoContent = {
	title: 'What Does a 10x10 Storage Unit Look Like?',
	background: 'dark',
	modules: [
		{
			type: 'videoSection',
			id: '10x10-video-content',
			props: {
				content: {
					pageType: 'SGP',
					title: 'What Does a 10x10 Storage Unit Look Like?',
					description:
						"Imagine a space that's:\n\n- 10 feet wide by 10 feet deep\n\n- About the size of a large bedroom or half a one-car garage\n\n- Tall enough to stack boxes and use vertical space efficiently\n\n- Spacious enough to create organized zones for different items",
				},
				imageSrc: videoImage,
			},
		},
	],
};

const TenByTenFullWidthTableContent = {
	title: ' Storage Size Comparison Guide',
	modules: [
		{
			type: 'sizeChart',
			props: {
				type: 'sizeChart',
				id: '10x10-full-width-table',
				title: 'Storage Size Comparison Guide',
				slug: 'size-chart-section',
				pageType: 'SGP',
				isFullWidth: true,
				image: fourColumnTableImage,
				description:
					"The 10x10 storage unit is a perfect mid-sized unit, versatile enough for most everyday storage needs, and an oversized item.\n\n Here's how the 10x10 unit stacks up against other [popular storage unit sizes](https://www.sparefoot.com/storage-unit-size-guide.html).",
				headers: [
					{
						label: 'Unit Size',
						key: 'UnitSize',
					},
					{
						label: 'Square Footage',
						key: 'SquareFootage',
					},
					{
						label: 'Best For',
						key: 'BestFor',
					},
					{
						label: 'Monthly Cost Range',
						key: 'MonthlyCostRange',
					},
				],
				rows: [
					{
						UnitSize: '5x5',
						SquareFootage: '25 sq ft',
						BestFor: 'Closet-sized storage',
						MonthlyCostRange: '$45-$85',
					},
					{
						UnitSize: '5x10',
						SquareFootage: '50 sq ft',
						BestFor: 'Small apartment extras',
						MonthlyCostRange: '$65-$120',
					},
					{
						UnitSize: '10x10',
						SquareFootage: '100 sq ft',
						BestFor: '1-2 bedroom apartment',
						MonthlyCostRange: '$85-$180',
					},
					{
						UnitSize: '10x15',
						SquareFootage: '150 sq ft',
						BestFor: '2-3 bedroom home',
						MonthlyCostRange: '$120-$220',
					},
					{
						UnitSize: '10x20',
						SquareFootage: '200 sq ft',
						BestFor: '3+ bedroom home',
						MonthlyCostRange: '$150-$280',
					},
				],
			},
		},
	],
};

const twoPanelData = {
	props: {
		title: 'What Can Fit in a 10x10 Storage Unit?',
		suffix: 'A 10x10 storage unit can typically accommodate:',
		type: 'two-panel',
		content: [
			{
				image: bedRoomImage,
				description:
					'### Bedroom Set:\n\n' +
					'- Queen or king mattress and box spring\n' +
					'- Dresser and nightstands\n' +
					'- Wardrobe or armoire\n' +
					'- Plus boxes of clothing and linens',
			},
			{
				image: furnitureImage,
				description:
					'### Living Room Set:\n\n' +
					'- Sofa and loveseat\n' +
					'- Coffee table and end tables\n' +
					'- Entertainment center\n' +
					'- Lamps and decorative items',
			},
		],
	},
};

const TenByTenTwoPanelContent = {
	title: 'What Can Fit in a 10x10 Storage Unit?',
	background: 'gray',
	modules: [
		{
			id: '10x10-two-panel',
			type: 'cardBlockContent',
			props: twoPanelData,
		},
	],
};

const threePanelData1 = {
	props: {
		title: 'Real-Life Storage Examples',
		type: 'three-panel',
		pageType: 'SGP',
		content: [
			{
				image: booksImage,
				description:
					'**College Student Package:**\n\n' +
					'- Dorm room furniture\n' +
					'- Textbooks and supplies\n' +
					'- Seasonal clothing\n' +
					'- Electronics and entertainment',
			},
			{
				image: movingImage,
				description:
					'**Family Seasonal Storage:**\n\n' +
					'- Holiday decorations\n' +
					'- Summer/winter clothing\n' +
					'- Sports equipment\n' +
					'- Outdoor furniture',
			},
			{
				image: shopImage,
				description:
					'**Small Business Setup:**\n\n' +
					'- Office furniture\n' +
					'- Inventory and supplies\n' +
					'- Files and documents\n' +
					'- Equipment and tools',
			},
		],
	},
};

const TenByTenThreePanelContent1 = {
	title: 'Real-Life Storage Examples',
	modules: [
		{
			id: '10x10-three-panel-1',
			type: 'cardBlockContent',
			props: threePanelData1,
		},
	],
};

const TenByTenThreeColumnTableContent = {
	title: 'Size Guide',
	modules: [
		{
			type: 'sizeChart',
			props: {
				type: 'sizeChart',
				image: threeColumnTableImage,
				slug: 'size-chart-section',
				columnWidths: [1, 3],
				title: '10x10 Storage Unit Cost & Pricing (2025)',
				pageType: 'SGP',
				id: '10x10-three-column-table',
				headers: [
					{
						label: 'Location Type',
						key: 'LocationType',
					},
					{
						label: 'Monthly Cost Range',
						key: 'MonthlyCostRange',
					},
					{
						label: 'Average Cost',
						key: 'AverageCost',
					},
				],
				rows: [
					{
						LocationType: 'Rural Areas',
						MonthlyCostRange: '$75-$120',
						AverageCost: '$95',
					},
					{
						LocationType: 'Suburban',
						MonthlyCostRange: '$90-$150',
						AverageCost: '$120',
					},
					{
						LocationType: 'Urban',
						MonthlyCostRange: '$120-$200',
						AverageCost: '$160',
					},
					{
						LocationType: 'Major Cities',
						MonthlyCostRange: '$150-$250',
						AverageCost: '$200',
					},
				],
			},
		},
	],
};

const threePanelData2 = {
	props: {
		title: 'Money-Saving Strategies',
		type: 'three-panel',
		pageType: 'SGP',
		content: [
			{
				image: timingImg,
				description:
					'### Timing Your Rental:\n\n' +
					'- Avoid peak moving season (May-September)\n' +
					'- Look for winter discounts and promotions\n' +
					'- Book during weekdays for better rates',
			},
			{
				image: saveMoneyImg,
				description:
					'### Promotional Deals:\n\n' +
					'- First month free offers\n' +
					'- Multiple-month discounts\n' +
					'- Student and military discounts\n' +
					'- Online booking incentives',
			},
			{
				image: homeImg,
				description:
					'### Smart Shopping Tips:\n\n' +
					'- Compare facilities within 10 miles\n' +
					'- Consider slightly smaller or larger units if significantly cheaper',
			},
		],
	},
};

const TenByTenThreePanelContent2 = {
	title: 'Money-Saving Strategies',
	modules: [
		{
			type: 'cardBlockContent',
			id: '10x10-three-panel-2',
			props: threePanelData2,
		},
	],
};

const reviews = [
	{
		reviewTitle: 'SpareFoot found me the best deal on space in...',
		reviewRating: 5,
		reviewText:
			'SpareFoot found me the best deal on space in very close proximity to my location, enabling me to save over $20 per month for a 10x10 space.',
		reviewerInitials: 'AD',
		reviewerName: 'Alfred Delisle',
		reviewDate: '',
		link: 'https://www.trustpilot.com/reviews/63b4e7a84d0773066a2d2b14',
	},
	{
		reviewTitle: 'I searched for a climate-controlled storage unit...',
		reviewRating: 5,
		reviewText:
			"I searched Google for a climate-controlled storage unit in my area and got a great deal on a 10x10 climate-controlled storage unit about 15 minutes away. It cost me nothing to reserve the unit and I got an email and a phone call confirming my reservation a short time later. Using SpareFoot made this process as easy and efficient as it could've been. Very happy user!",
		reviewerInitials: 'KK',
		reviewerName: 'Kris Kennedy',
		reviewDate: '',
		link: 'https://www.trustpilot.com/users/5eb6eef4c66da359fe8131d6',
	},
	{
		reviewTitle: 'Easy to use!',
		reviewRating: 5,
		reviewText:
			'Easy to use! I found a great deal on a 10x10 climate-controlled storage room!',
		reviewerInitials: 'ES',
		reviewerName: 'ERIC Sichler',
		reviewDate: '',
		link: 'https://www.trustpilot.com/reviews/5c8553a497afa109fccc5adb',
	},
	{
		reviewTitle: 'Great help finding a storage unit.',
		reviewRating: 5,
		reviewText:
			'SpareFoot helped me find the cheapest 10x10 drive-up storage in my area. Very helpful.',
		reviewerInitials: 'CH',
		reviewerName: 'Christopher Howder',
		reviewDate: '',
		link: 'https://www.trustpilot.com/reviews/5642ba070000ff000919199e',
	},
];

const TenByTenReviewsContent = {
	title: '10x10 reviews',
	background: 'dark',
	pageType: 'SGP',
	modules: [
		{
			type: 'reviews',
			id: '10x10-reviews',
			props: {
				pageType: 'SGP',
				reviews,
				title: 'Find the Best 10x10 Storage Units with SpareFoot',
			},
		},
	],
};

const faqs = [
	{
		question: 'How big is a 10x10 storage unit, and what can I fit inside?',
		answer: `A 10x10 storage unit provides 100 square feet of storage space – roughly the size of a large bedroom or half a one-car garage. With 8-foot ceilings (sometimes higher), you get about 800 cubic feet of total storage capacity.\n\n
What can fit in a 10x10 storage unit includes furniture from a 1-2 bedroom apartment, such as a complete bedroom set (bed, dresser, nightstands), a living room set (sofa, chairs, coffee table), plus dozens of boxes. You could also store major appliances like a refrigerator or washer/dryer, seasonal items, business inventory, or hobby equipment.
`,
	},
	{
		question: 'How much does a 10x10 storage unit cost per month?',
		answer: `The 10x10 storage unit cost typically ranges from $85 to $250 per month, depending on your location and facility features. Rural areas average around $95 monthly, suburban locations cost about $120, while major cities can reach $200 or more.`,
	},
	{
		question:
			'What does a 10x10 storage unit look like, and how should I organize it?',
		answer: `A 10x10 storage unit looks like a small room or large walk-in closet – it's 10 feet wide, 10 feet deep, with 8-foot ceilings (some facilities offer 9-10-foot ceilings). The space is typically concrete-floored with metal walls and a roll-up door for access.\n\n
For an organization, think vertically and create zones. Stack boxes along the walls with the heaviest on the bottom, use furniture pieces as storage containers by filling drawers and wardrobes, and leave a narrow aisle down the middle for access. Consider investing in metal shelving units to maximize vertical space and keep frequently used items easily accessible.
`,
	},
	{
		question: 'Do I need climate control for my 10x10 storage unit?',
		answer: `Climate control isn't necessary for all items, but it's worth considering based on what you're storing and your local climate. Standard 10x10 storage works fine for furniture, books, clothing, and household items in moderate climates. However, climate control becomes valuable for electronics, wooden furniture, important documents, artwork, musical instruments, and anything sensitive to temperature or humidity changes.\n\n
Consider climate control if you live in an area with extreme temperatures (regularly above 90°F or below 20°F), high humidity, or dramatic seasonal changes. It's also smart for long-term storage – anything you plan to store for more than a year benefits from stable conditions.
`,
	},
	{
		question:
			'Can I access my 10x10 storage unit anytime I need something?',
		answer: `Most storage facilities offer extended access hours, typically 6 AM to 10 PM daily, including weekends. Some facilities provide 24/7 access, which is particularly convenient for people with non-traditional schedules or those who need to retrieve items outside business hours. When choosing a facility, consider your typical schedule and access needs. If you frequently need items during off-hours, prioritize facilities with 24/7 access.`,
	},
	{
		question: 'How do I prepare items for storage in my 10x10 unit?',
		answer: `Proper preparation prevents damage and makes retrieval easier. Clean all items thoroughly before storage – dust furniture, wash and completely dry clothing, and wipe down appliances. Disassemble furniture when possible to save space and prevent damage, keeping hardware in labeled bags taped to the corresponding pieces.\n\n
Use quality packing materials: sturdy boxes, bubble wrap, furniture pads, and moisture absorbers. Avoid plastic bags for clothing (they can trap moisture), instead, use wardrobe boxes or vacuum-sealed bags. Fill hollow items like appliances or furniture with smaller items to maximize space efficiency.\n\n
Create a detailed inventory with photos, and consider making a simple map showing where items are located in your unit. Pack a "first day" box with essentials you might need immediately, and place it near the front. Use uniform box sizes when possible – they stack better and create a more organized appearance. Label boxes on multiple sides and use a consistent system (room-based, category-based, or priority-based) to make finding items easier later.
`,
	},
];

const TenByTenFAQContent = {
	title: '10x10 faq',
	background: 'gray',
	modules: [
		{
			type: 'faqs',
			id: '10x10-faqs',
			props: {
				header: '10x10 Storage Unit Size FAQs',
				faqs,
			},
		},
	],
};

const TenByTenRelatedContent = {
	title: '10x10 Related Content',
	noPaddingBottom: true,
	modules: [
		{
			type: 'featuredContent',
			id: '10x10-related-content',
			props: {
				title: 'Learn More About Storage Unit Size Options',
				slug: '10x10-featured-content',
				pageType: 'SGP',
				contentCards: [
					{
						title: 'General Storage Advice',
						date: 'August 7, 2025',
						image: generalAdvice,
						content: 'How to Pick the Right Size Self Storage Unit',
						link: 'https://www.sparefoot.com/blog/how-to-pick-the-right-size-storage-unit',
					},
					{
						title: 'General Storage Advice',
						date: 'October 17, 2025',
						image: generalAdvice2,
						content: 'How Are Storage Units Measured?',
						link: 'https://www.sparefoot.com/blog/how-are-storage-units-measured',
					},
					{
						title: 'General Storage Advice',
						date: 'October 17, 2025',
						image: generalAdvice3,
						content: 'What Can You Fit in a 10x10 Storage Unit?',
						link: 'https://www.sparefoot.com/blog/10x10-storage-unit-size-guide',
					},
					{
						title: 'General Storage Advice',
						date: 'October 31, 2025',
						image: generalAdvice4,
						content: 'What Can You Fit in a 10x15 Storage Unit?',
						link: 'https://www.sparefoot.com/blog/what-can-you-fit-inside-of-a-10x15-storage-unit',
					},
				],
			},
		},
	],
};

const TenByTenMoreWaysToStoreContent = {
	title: '10x10 More Ways to Store',
	background: 'gray',
	modules: [
		{
			type: 'links',
			id: '10x10-more-ways-to-store-cards',
			props: {
				title: 'More Ways to Store',
				pageType: 'SGP',
				cards: ['ClimateControl', 'Business', '10x15', '5x15'],
			},
		},
	],
};

const TenByTenNearbyCitiesContent = {
	title: 'nearby units',
	modules: [
		{
			type: 'storageNearYou',
		},
	],
};

const TenByTenAlternatingContent2 = {
	title: 'Alternate Content Section 2',
	modules: [
		{
			type: 'alternatingContent',
			id: '10x10-alternating-content-2',
			props: {
				props: {
					title: 'Is a 10x10 Storage Unit Right for You?',
					additionalProps: {
						paragraph: {
							color: 'black',
						},
					},
					content: [
						{
							image: minMaxImg,
							title: 'Maximum Value, Minimum Hassle',
							description:
								'In the world of self-storage, 10x10 units offer exceptional value because they:\n\n' +
								'- Generally cost less than larger units while providing ample space\n' +
								'- Fit standard-sized furniture and [appliances](https://www.sparefoot.com/blog/how-to-store-kitchen-appliances)\n' +
								'- Allow easy organization with room to walk around\n' +
								'- Work for both [short-term](https://www.sparefoot.com/blog/the-best-ways-to-use-storage-during-a-move) and long-term storage needs',
						},
						{
							image: versatileImg,
							title: 'Versatile Storage Solutions',
							description:
								"A 10x10 storage unit adapts to your changing needs without breaking the budget, whether you're storing:\n\n" +
								'- Bedroom or living room furniture sets\n' +
								'- Seasonal decorations and clothing\n' +
								'- Sports equipment and hobby gear\n' +
								'- Small appliances and electronics\n' +
								'- [Business inventory and supplies](https://www.sparefoot.com/business-storage.html)',
						},
					],
				},
			},
		},
	],
};

const TenByTenAlternatingContent1 = {
	title: 'Alternate Content Section 1',
	modules: [
		{
			type: 'alternatingContent',
			id: '10x10-alternating-content-1',
			props: {
				props: {
					title: 'Looking for a Medium Storage Unit?',
					description:
						"If you're here, chances are that you're looking for a medium storage unit to give your stuff a new home. Lucky for you, SpareFoot has a variety of storage unit sizes to suit your medium storage needs. Here's your Goldilocks storage unit menu to help you find the best storage space:",
					additionalProps: {
						paragraph: {
							color: 'black',
						},
					},
					content: [
						{
							title: '',
							image: altImg,
							description:
								'**Medium Units:** 10x10 (*you are here*), 10x15, 5x15\n\n' +
								'**Small Units:** 5x5, 5x10, Mini storage, Storage lockers\n\n' +
								'**Large Units:** 10x20, 10x25, 10x30',
						},
					],
				},
			},
		},
	],
};

const TenByTenAlternatingContent3 = {
	title: 'Alternate Content Section 3',
	background: 'gray',
	modules: [
		{
			type: 'alternatingContent',
			id: '10x10-alternating-content-3',
			props: {
				props: {
					title: 'Pro Packing Tips',
					additionalProps: {
						paragraph: {
							color: 'black',
						},
					},
					content: [
						{
							image: packingTipsImg,
							description:
								'- Stack boxes along walls, heaviest on the bottom\n' +
								'- Use furniture as storage (fill dressers and wardrobes)\n' +
								'- Create an aisle down the middle for easy access\n' +
								'- Keep frequently needed items near the front\n\n' +
								'[Check out the SpareFoot storage size calculator](https://www.sparefoot.com/storage-unit-size-guide.html) to get an in-depth look at how your items stack up against available storage unit sizes.',
						},
					],
				},
			},
		},
	],
};

const TenByTenAlternatingContent4 = {
	title: 'Alternate Content Section 3',
	background: 'gray',
	modules: [
		{
			type: 'alternatingContent',
			id: '10x10-alternating-content-4',
			props: {
				props: {
					title: 'How Much Does a 10x10 Storage Unit Cost Per Month?',
					description:
						'The 10x10 storage unit cost varies significantly based on several factors',
					additionalProps: {
						paragraph: {
							color: 'black',
						},
					},
					content: [
						{
							image: locationImg,
							title: 'Location Factors:',
							description:
								'- Urban areas cost 50-100% more than rural locations\n' +
								'- Coastal cities typically have higher rates\n' +
								'- Supply and demand in your specific area',
						},
						{
							image: amenitiesImg,
							title: 'Facility Features:',
							description:
								'- **Standard units**: Base pricing\n' +
								'- **Climate-controlled**: Add $30-$60 monthly\n' +
								'- **Indoor access**: Premium of $10-$30\n' +
								'- **Enhanced security**: Minimal additional cost',
						},
					],
				},
			},
		},
	],
};

export const TenByTenContent = {
	type: '10x10',
	pageType: pageTypes.SGP,
	sections: [
		TenByTenHeroContent,
		TenByTenNearbyUnitsContent,
		TenByTenAlternatingContent1,
		TenByTenIconContent,
		TenByTenAlternatingContent2,
		TenByTenSmallTableContent,
		TenByTenVideoContent,
		TenByTenFullWidthTableContent,
		TenByTenTwoPanelContent,
		TenByTenThreePanelContent1,
		TenByTenAlternatingContent3,
		TenByTenThreeColumnTableContent,
		TenByTenAlternatingContent4,
		TenByTenThreePanelContent2,
		TenByTenReviewsContent,
		TenByTenFAQContent,
		TenByTenRelatedContent,
		TenByTenMoreWaysToStoreContent,
		TenByTenNearbyCitiesContent,
	],
};
